import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './theme/themes.css'; // theme tokens resolve site-wide (dark default)
import App from './App';
import { isDiscordActivity } from './activity/isActivity';
import reportWebVitals from './reportWebVitals';

// Lazy on purpose. The Embedded App SDK is ~48kB gzipped and only the Discord
// iframe ever needs it, so a static import would put it in the main bundle for
// every web visitor. This keeps it in its own chunk, fetched only inside the
// activity.
const ActivityApp = React.lazy(() => import('./activity/ActivityApp'));

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// Inside Discord's iframe the normal app is the wrong thing to boot: the
// cookie session can't cross into a third-party frame, so it would render the
// logged-out landing page (which is exactly what Phase 0 showed). The activity
// shell authenticates through the Embedded App SDK instead.
root.render(
  <React.StrictMode>
    {isDiscordActivity() ? (
      <React.Suspense fallback={null}>
        <ActivityApp />
      </React.Suspense>
    ) : (
      <App />
    )}
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
